import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { noLeadingSpaces } from '../../../../../../assets/utility/form.validators';
import { SPECIAL_CHARACTERS_REGEX_VALIDATION } from '../../../../../../assets/const';
import { FormUtilityService } from '../../../../core/services/form-utility.service';
import { BeyAuthAsideBrandingComponent } from '../../../components/bey-auth-aside-branding/bey-auth-aside-branding.component';
import { BeyButtonComponent } from '../../../../shared/components/bey-button/bey-button.component';
import { BeyInputComponent } from '../../../../shared/components/bey-input/bey-input.component';
import { RegistrationLayoutComponent } from '../../../../shared/components/registration-layout/registration-layout.component';
import { GetElementIdDirective } from '../../../../shared/directives/get-element-id.directive';

@Component({
  selector: 'bey-confirm-nin',
  templateUrl: './confirm-nin.component.html',
  styleUrls: ['./confirm-nin.component.scss'],
  standalone: true,
  imports: [
    RegistrationLayoutComponent,
    ReactiveFormsModule,
    BeyInputComponent,
    BeyButtonComponent,
    BeyAuthAsideBrandingComponent,
    GetElementIdDirective,
  ],
})
export class ConfirmNinComponent implements OnInit {
  form: UntypedFormGroup;

  @Output()
  onNext: EventEmitter<{ formGroup: UntypedFormGroup; step: number }> = new EventEmitter<{
    formGroup: UntypedFormGroup;
    step: number;
  }>();

  constructor(public formUtility: FormUtilityService) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      id_number: new UntypedFormControl('', [
        Validators.required,
        noLeadingSpaces,
        Validators.pattern(SPECIAL_CHARACTERS_REGEX_VALIDATION),
        Validators.maxLength(50),
      ]),
    });
  }

  handleSubmit() {
    this.onNext.emit({
      step: 1,
      formGroup: this.form,
    });
  }
}
